function initialState() {
  return {
    OIDCUser: {},
    User: {},
    sideNavCollapsed: false
  }
}

const state = initialState()

const getters = {
  authToken: function (state) {
    return 'Bearer ' + state.OIDCUser.access_token
  },
  OIDCUser: function () {
    return state.OIDCUser
  },
  User: function (state) {
    return state.User
  },
  sideNavCollapsed: function (state) {
    return state.sideNavCollapsed
  }
}

const actions = {
  storeOIDCUser: function (context, val) {
    return new Promise((resolve, reject) => {
      context.commit('storeOIDCUser', val)
      resolve();
    })
  },
  setCurrentUser: function (context, val) {
    return new Promise((resolve, reject) => {
      context.commit('setCurrentUser', val)
      resolve();
    })
  },
  toggleSideNav: function (context, val) {
    return new Promise((resolve, reject) => {
      context.commit('toggleSideNav', val)
      resolve();
    })
  },
  userUpdated: function (context, val) {
    return new Promise((resolve, reject) => {
      if (val.Id == context.getters.User.Id) {
        context.commit('userUpdated', val)
      }
      resolve();
    })
  },
  handleUserFavoriteResponse: function (context, data) {
    context.commit('handleUserFavoriteResponse', data);
  },
}

const mutations = {
  storeOIDCUser: function (state, OIDCUser) {
    state.OIDCUser = Object.assign({}, OIDCUser)
  },
  setCurrentUser: function (state, User) {
    state.User = Object.assign({}, User)
  },
  toggleSideNav: function (state, sideNavVal) {
    state.sideNavCollapsed = sideNavVal;
  },
  userUpdated: function (state, updatedUser) {
    if (state.User.Id == updatedUser.Id) {
      let isFavorite = state.User.IsFavorite;
      for (var prop in updatedUser) {
        try {
          state.User[prop] = updatedUser[prop];
        } catch (err) {
          console.log('Error copying property');
        }
      }
      state.User.IsFavorite = isFavorite;
      state.User = Object.assign({}, state.User)
    }
  },
  handleUserFavoriteResponse: function (state, updatedUser) {
    if (state.User.Id == updatedUser.Id) {
      state.User.IsFavorite = updatedUser.IsFavorite;
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/App.js